/**
 * Init Splide pour le hero (max-hero).
 * Chargé en <script defer> APRÈS splide.min.js (UMD global `Splide`).
 * Lit les options depuis les data-* posés par la section.
 */
(function () {
  // Doit rester aligné sur le breakpoint du CSS de la section (749px).
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Écoute compatible : addEventListener sur MediaQueryList date de Safari 14.
  function onMqChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  // Une vidéo ne doit tourner que si elle correspond à l'écran courant. Sans classe de
  // bascule, elle sert les deux écrans (pas de vidéo mobile distincte) -> toujours bonne.
  function matchesViewport(video) {
    if (video.classList.contains('max-hero__media--desktop')) return !mqMobile.matches;
    if (video.classList.contains('max-hero__media--mobile')) return mqMobile.matches;
    return true;
  }

  function mount(el) {
    if (!el || el.dataset.splideMounted === '1') return;
    if (typeof window.Splide === 'undefined') return;

    el.dataset.splideMounted = '1';

    var splide = new window.Splide(el, {
      // Toujours 'slide' (jamais 'loop') pour ne PAS cloner les slides dans le DOM (SEO).
      // La "boucle infinie" du réglage est rendue par rewind = retour au 1er slide, sans clone.
      type: 'slide',
      perPage: 1,
      perMove: 1,
      arrows: el.dataset.arrows === 'true',
      pagination: el.dataset.dots === 'true',
      drag: true,
      keyboard: true,
      speed: 500,
      rewind: el.dataset.loop === 'true',
    });

    // Accessibilité : Splide ne retire pas les slides cachés du focus. Sans ça, l'utilisateur
    // clavier tabule sur les boutons de slides invisibles. `inert` les retire d'un coup du
    // focus ET des lecteurs d'écran.
    var syncInert = function () {
      var slides = el.querySelectorAll('.splide__slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].inert = !slides[i].classList.contains('is-active');
      }
    };

    // Vidéos de fond : le Liquid les sort sans `autoplay` et en preload="none", donc RIEN
    // n'est téléchargé tant qu'on n'a pas explicitement démarré la bonne. Sans ça, un
    // carrousel de 3 slides vidéo lancerait 3 téléchargements en parallèle au chargement —
    // exactement le genre de coût qui a déjà plombé le LCP de cette section.
    // Son : coupé par défaut — aucun navigateur n'autorise une lecture automatique sonore.
    // Le bouton du slide l'active ; le choix vaut pour tout le carrousel et survit aux
    // changements de slide (la vidéo du slide quitté se met en pause, donc se tait).
    var soundOn = false;

    var setSound = function (on) {
      soundOn = on;
      var buttons = el.querySelectorAll('[data-max-hero-sound]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        buttons[i].setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
      }
    };

    var syncVideos = function () {
      var slides = el.querySelectorAll('.splide__slide');
      for (var i = 0; i < slides.length; i++) {
        var active = slides[i].classList.contains('is-active');
        var videos = slides[i].querySelectorAll('video.max-hero__video');
        for (var j = 0; j < videos.length; j++) {
          var video = videos[j];
          // prefers-reduced-motion : on s'en tient au poster, jamais d'animation subie.
          if (active && matchesViewport(video) && !mqReduce.matches) {
            // Muet tant que le visiteur n'a pas demandé le son : obligatoire pour que play()
            // passe sans geste utilisateur (l'attribut seul ne suffit pas si un script tiers
            // a touché la propriété).
            video.muted = !soundOn;
            if (video.preload === 'none') video.preload = 'auto';
            var playing = video.play();
            // Safari rejette la promesse si l'onglet est en arrière-plan : sans catch, ça
            // remonte en "Unhandled Promise Rejection" dans la console. Refus de la lecture
            // SONORE (NotAllowedError) : on retombe en muet plutôt que de rester figé.
            if (playing && playing.catch) {
              playing.catch(
                (function (v) {
                  return function (err) {
                    if (err && err.name === 'NotAllowedError' && !v.muted) {
                      setSound(false);
                      v.muted = true;
                      var retry = v.play();
                      if (retry && retry.catch) retry.catch(function () {});
                    }
                  };
                })(video)
              );
            }
          } else {
            video.pause();
          }
        }
      }
    };

    // Bouton son : bascule, et à l'activation la vidéo visible repart du début — une pub
    // s'écoute en entier. Le bouton est hors du lien plein cadre : jamais de navigation.
    el.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-max-hero-sound]');
      if (!btn) return;
      event.preventDefault();
      var turnOn = !soundOn;
      setSound(turnOn);
      var slide = btn.closest('.splide__slide');
      var videos = slide ? slide.querySelectorAll('video.max-hero__video') : [];
      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        if (!matchesViewport(video)) continue;
        video.muted = !turnOn;
        if (turnOn) {
          try {
            video.currentTime = 0;
          } catch (e) {}
          if (video.preload === 'none') video.preload = 'auto';
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      }
    });

    // Changement de breakpoint (rotation de l'écran, redimensionnement) : la vidéo qui
    // devient visible doit prendre le relais de celle qui se masque.
    onMqChange(mqMobile, syncVideos);
    onMqChange(mqReduce, syncVideos);

    splide.mount();

    // À appeler APRÈS mount(), et surtout PAS via l'événement 'mounted' : Splide ne pose
    // `is-active` qu'en RÉPONSE à cet événement (chaque composant Slide s'y abonne pendant
    // mount()), et les handlers s'exécutent dans leur ordre d'enregistrement. Le nôtre, posé
    // avant mount(), passait donc AVANT que la classe n'existe : aucun slide n'était
    // `is-active`, tous devenaient inert — y compris le visible. Et comme `inert` s'hérite,
    // les boutons du hero étaient morts au chargement (seules les flèches, hors slides,
    // répondaient encore).
    // Ici mount() est terminé, donc `is-active` est déjà posé : l'état initial est correct.
    syncInert();
    syncVideos();
    splide.on('moved', function () {
      syncInert();
      syncVideos();
    });
  }

  function mountAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.max-hero-splide').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll();
    });
  } else {
    mountAll();
  }

  // Éditeur de thème : re-mount quand la section est rechargée
  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });
})();
